import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Space } from 'antd';
import { CoExcluded } from './CoExcluded';
import { CoIdentified } from './CoIdentified';
export const Route = createFileRoute('/console/$orgId/configuration/compliance/mspr/critical-operations')({
    component: CriticalOperations,
    staticData: {
        ui: {
            useParentTitle: true,
        },
    },
});

function CriticalOperations() {
    return (
        <PageController route={Route}>
            <Space orientation="vertical" className="w-full" size="large">
                <Outlet />
                <CoIdentified />
                <CoExcluded />
            </Space>
        </PageController>
    );
}
